import { useMemo } from 'react';
import { useSkipReasonText } from 'src/components/formEditor/controls/Inputs/base/hooks';
import { useContextSelector } from 'use-context-selector';
import { Field } from '../../components/Field';
import { RecordContext } from '../../RecordContext';
import { ICalculatedInput } from 'src/features/forms/base/controls/specials/CalculatedBlock';

export const CalculatedInput: ICalculatedInput = ({ label, dataKey, units, skipCheckBoxText, hideLabel }) => {
  const inputValue = useContextSelector(RecordContext, (v) => v.formResult?.[dataKey]);
  const singleInputValue = Array.isArray(inputValue) ? inputValue[0] : inputValue;
  const skipReason = useContextSelector(RecordContext, (v) => v.skipReasons?.[dataKey]);
  const skipReasonText = useSkipReasonText(skipReason, skipCheckBoxText);

  const answerValue = useMemo(() => {
    if (skipReason !== undefined) {
      return skipReasonText;
    }

    return singleInputValue ? `${singleInputValue} ${units ?? ''}` : null;
  }, [singleInputValue, skipReason, skipReasonText, units]);

  return <Field hideLabel={hideLabel} label={label ?? dataKey} value={answerValue} />;
};
